import React, { FC } from 'react'
import { Button as BootBtn } from 'react-bootstrap'
import { ClickAwayListener, Grow, Paper, Popper, ListItemText } from '@material-ui/core'
import './styles.scss'

interface Props {
  open: boolean
  firstName: string
  anchorRef: React.RefObject<HTMLButtonElement>
  setOpen: (value: boolean) => void
  ExportType: string
}

const ExportPopper: FC<Props> = ({ anchorRef, firstName, open, setOpen, ExportType }) => {
  const PoperMessage =
    ExportType === 'relatedProspect'
      ? `${firstName}’s related prospects information has been collected and sent to your email address. May your conversations be top notch. `
      : `${firstName}’s intel information has been collected and sent to your email address. May your conversations be top notch. `
  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      style={{
        zIndex: 2,
      }}
    >
      {({ TransitionProps, placement }): JSX.Element => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper style={{ maxWidth: 400, float: 'right' }}>
            <ClickAwayListener onClickAway={(): void => setOpen(false)}>
              <div className="export-form">
                <ListItemText>{PoperMessage}</ListItemText>
                <BootBtn variant="primary" block onClick={(): void => setOpen(false)}>
                  AWESOME, THANKS!
                </BootBtn>
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}

export default ExportPopper
